import { NgModule } from '@angular/core';

import { AlternateTranslationPipe } from './alternate-translations.pipe';
import { AuthorColorPipe } from './author-color.pipe';
import { DateByTimeZonePipe } from './date-custom.pipe';
import { EmojisPipe } from './emojis.pipe';
import { LongTextPipe } from './long-text.pipe';
import { PhonePipeLib } from './phonePipeLib.pipe';
import { PlainTextPipe } from './plainText.pipe';
import { SanitizeHtmlPipe } from './sanitizeHtml.pipe';
import { ShortNamePipe } from './shortName.pipe';
import { sortPipe } from './sort.pipe';

@NgModule({
  declarations: [
    sortPipe,
    SanitizeHtmlPipe,
    PlainTextPipe,
    PhonePipeLib,
    LongTextPipe,
    AlternateTranslationPipe,
    AuthorColorPipe,
    ShortNamePipe,
    DateByTimeZonePipe,
    EmojisPipe,
  ],
  exports: [
    sortPipe,
    SanitizeHtmlPipe,
    PlainTextPipe,
    PhonePipeLib,
    LongTextPipe,
    AlternateTranslationPipe,
    AuthorColorPipe,
    ShortNamePipe,
    DateByTimeZonePipe,
    EmojisPipe,
  ],
})
export class ChatPipesModule {}
